import React from "react";
import { Stack, Typography, useTheme } from "@mui/material";

interface SectionHeaderProps {
  title: string;
  count: number;
  countLabel?: string;
  rightElement?: React.ReactNode;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  count,
  countLabel,
  rightElement,
}) => {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      width="100%"
      padding={theme.nawy.spacing.sm}
      bgcolor={theme.nawy.colors.semantic.layer.primary}
    >
      <Stack direction="row" alignItems="center" gap={theme.nawy.spacing.xxs}>
        <Typography
          sx={{
            ...theme.nawy.typography.english.variants.headline.sm,
            color: theme.nawy.colors.semantic.text.primary,
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            ...theme.nawy.typography.english.variants.body.sm,
            color: theme.nawy.colors.semantic.text.secondary,
          }}
        >
          ({count}
          {countLabel ? ` ${countLabel}` : ""})
        </Typography>
      </Stack>
      {rightElement}
    </Stack>
  );
};

export default SectionHeader;
